import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { inject, onMounted, onUnmounted, provide, Ref, ref } from 'vue';
import GlobalConfig from '@/scripts/GlobalConfig';
import ProvideKey from '@/scripts/ProvideKey';
import GlobalStore from './scripts/GlobalStore';
import GlobalSesion from './scripts/GlobalSession';
import Measure from './scripts/measure';
import { Session } from './router';
import Report from './scripts/reportConfig';
import Language from './scripts/Language';
import chineseLanguage from './scripts/ChineseLanguage';
import screenfull from 'screenfull';
import { ElMessageBox } from 'element-plus';



export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const globalConfig = ref(new GlobalConfig())
const globalStore = ref(new GlobalStore())
const globalSession = ref(new GlobalSesion())
const measure = ref(new Measure())
const report = ref(new Report())
const langue = ref(chineseLanguage)


provide<Ref<GlobalConfig>>(ProvideKey.GLOBAL_CONFIG, globalConfig)
provide<Ref<GlobalStore>>(ProvideKey.GLOBAL_STORE, globalStore)
provide<Ref<GlobalSesion>>(ProvideKey.GLOBAL_SESSION, globalSession)
provide<Ref<Measure>>(ProvideKey.GLOBAL_MEASURE, measure)
provide<Ref<Report>>(ProvideKey.GLOBAL_REPORT, report)
provide<Ref<Language>>(ProvideKey.LANGUAGE, langue)




onMounted(() => {
  Session.value = globalSession.value
  if (!screenfull.isFullscreen) {
    ElMessageBox.confirm(
      langue.value.recordTip4,
      {
        confirmButtonText: langue.value.openFullScreen,
        cancelButtonText: langue.value.currentSituation,
        type: 'info',
      }
    ).then(() => {
      if (screenfull.isEnabled) {
        screenfull.toggle()
      }
    })
  }
})
const keydownHandler = (event: KeyboardEvent) => {

  switch (event.key) {
    case 'F5':
      event.preventDefault();
      break
    case 'F6':
      event.preventDefault();
      break
    case 'F7':
      event.preventDefault();
      break
    case 'F8':
      event.preventDefault();
      break
    case 'F9':
      break
  }
}

onMounted(() => {
  window.addEventListener("keydown", keydownHandler)
})

onUnmounted(() => {
  window.removeEventListener("keydown", keydownHandler)
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})